// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"343":"7b226a31","818":"7b226a31","965":"7b226a31"}[chunkId] + ".chunk.css";
};